angular.module('angus.directives').directive('header', [
    function() {
        return {
            templateUrl: 'templates/authenticated/layout/header/header.html'
        };
    }
]);